import { Alert } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { Event, useEvent } from 'api/event';

import { Helmet } from 'react-helmet';

import { Box, CustomBox, GridChild, GridContainer } from 'common';
import { useEffect, useState } from 'react';
import { EventCard } from 'widgets/cards';
import { eventsPageLabels } from '../../locales/translations'
import { useLanguage } from '../../context/LanguageContext';

export const EventsPage = () => {
    const [eventList, setEventList] = useState<Event[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const { language } = useLanguage();
    const title = eventsPageLabels.title[language];
    const pageTitle = eventsPageLabels.pageTitle[language];
    const metaDescription = eventsPageLabels.metaDescription[language];

    const { onGetAllEvent } = useEvent();

    useEffect(() => {
        (async () => {
            try {
                const result = await onGetAllEvent();
                if (result.success) {
                    const filteredAndSortedEvents = result.data
                        .filter((a: Event) => a.show) // Отображаем только события с show === true
                        .sort((a: Event, b: Event) => 
                            new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
                        );
                    setEventList(filteredAndSortedEvents);
                } else {
                    setError('Произошла ошибка при загрузке новостей');
                }
            } catch (error: any) {
                setError(error.message || 'Неизвестная ошибка');
            } finally {
                setLoading(false);
            }
        })();
    }, [onGetAllEvent]);

    return (
        <CustomBox title={title}>
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={metaDescription} />
            </Helmet>
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CircularProgress />
                </Box>
            ) : error ? (
                <Alert severity="error">{error}</Alert>
            ) : (
                <Box>
                    <GridContainer>
                        {eventList.map((eventItem) => (
                            <GridChild md={3} key={eventItem.id}>
                                <EventCard eventsItem={eventItem} />
                            </GridChild>
                        ))}
                    </GridContainer>
                </Box>
            )}
        </CustomBox>
    );
};
